import { Link } from "react-router-dom";
import { Lock, Sparkles, Check } from "lucide-react";
import { LeafletMap } from "@/components/map/LeafletMap";
import { Button } from "@/components/ui/button";

export function LockedMap({ message, price }) {
  return (
    <div data-testid="locked-map" className="relative h-full w-full overflow-hidden bg-slate-950">
      <div className="absolute inset-0 blur-md md:blur-lg opacity-40 pointer-events-none"><LeafletMap interactive={false} /></div>
      <div className="absolute inset-0 grid place-items-center p-6">
        <div className="max-w-lg w-full rounded-2xl backdrop-blur-xl bg-slate-900/85 text-white border border-emerald-500/30 p-8 shadow-2xl fade-up">
          <span className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-[0.2em] text-emerald-400"><Lock size={12} /> Premium feature gated</span>
          <h2 data-testid="locked-map-message" className="mt-4 text-2xl sm:text-3xl font-extrabold tracking-tight">{message}</h2>
          <p className="mt-3 text-slate-300">Unlock high-resolution Chhattisgarh cadastral maps — plot boundaries, khasra search, owner &amp; area details.</p>
          <ul className="mt-5 space-y-2 text-sm text-slate-200">
            {["Interactive parcel boundaries across 12 districts", "Search by khasra, owner or village", "Leaflet & Google Maps engines", "7-day free trial on your first card"].map((t) => (
              <li key={t} className="flex items-center gap-2"><Check size={14} className="text-emerald-400" />{t}</li>
            ))}
          </ul>
          <div className="mt-6 flex items-end gap-2"><span className="font-mono text-4xl font-semibold">₹{price}</span><span className="text-slate-400 mb-1">/ month · cancel anytime</span></div>
          <Button asChild data-testid="locked-map-upgrade-button" size="lg" className="mt-6 w-full rounded-full h-12 font-semibold text-white hover:opacity-90" style={{ background: "var(--terracotta)" }}>
            <Link to="/pricing"><Sparkles size={16} className="mr-2" />Upgrade to Premium</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
